export const INIT_LOAD_PARAMS = { offset: 0, limit: 100 };
export const NUM_OF_ID_CHARS_REQ_BEFORE_API_REQ = 4;
export const REASON_CLEAR = 'clear'; // clear button pressed
export const REASON_INPUT = 'input'; // user change
export const REASON_SELECT_OPTION = 'select-option';
